import { currencyExist } from "./createRequestBody";

export const createFeaturedPubRequestBody = ({ filters, size, restFilters }) => {
  const finalFilters = {
    ...filters,
    ...restFilters,
  };

  try {
    const request = {
      query: {
        bool: {
          must: [...filterTerms(finalFilters)],
        },
      },
      sort: {
        publicationDate: {
          order: "desc",
        },
      },
      size,
      _source: [
        "analysts",
        "internal",
        "pageCount",
        "regions",
        "id",
        "title",
        "publicationDate",
        "assetClasses",
        "synopsis",
        "gicsIndustryGroups",
        "reportTypes",
        "reportTitles",
        "txCategories",
        "txSubCategories",
        "periodicals",
        "primaryPeriodicals",
        "resources",
        "customData.featured",
        "customData.coverImage",
        "instrumentation.wordCount",
        "language",
        "aiSummary",
      ],
      from: 0,
    };

    if (currencyExist(filters)) {
      request.query.bool.must_not = [
        {
          term: { "txCategories.en": "Equity" },
        },
      ];
    }

    return request;
  } catch (err) {
    console.error("Unable to create featured search request: ", err);
    return {};
  }
};
const filterTerms = (filters = {}) =>
  Object.entries(filters).map(([key, arr]) => ({
    bool: {
      should: toArray(arr).map((value) => ({ term: { [key]: value } })),
    },
  }));

const toArray = (item) => (Array.isArray(item) ? item : [item]);
